import { FormInput, FormSelect } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { X } from "lucide-react";
import { capitalize } from "@/lib/utils";
import { GRADE, MODULE, SUB_MODULE } from "../consts";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isMobile,
    action,
    isEdit,
    isLoading,
    gradeOptions,
    moduleOptions,
    isModulesLoading,
    isGradesLoading,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {isEdit ? "Update" : capitalize(action || "")} Sub Module
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[100px] px-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[25px]">
                <FormSelect
                  name={GRADE}
                  control={form.control}
                  label="Grade"
                  error={errors[GRADE]?.message}
                  isRequired={requiredFields.includes(GRADE)}
                  disabled={isView || isEdit}
                  options={gradeOptions}
                  placeholder={isGradesLoading ? "Loading..." : "Please enter"}
                />
                <FormSelect
                  name={MODULE}
                  control={form.control}
                  label="Module"
                  error={errors[MODULE]?.message}
                  isRequired={requiredFields.includes(MODULE)}
                  disabled={isView || isEdit}
                  options={moduleOptions}
                  placeholder={isModulesLoading ? "Loading..." : "Please enter"}
                />
                <div className="md:col-span-2">
                  <FormInput
                    name={SUB_MODULE}
                    control={form.control}
                    label="Sub Module Name"
                    placeholder="Please enter"
                    error={errors[SUB_MODULE]?.message}
                    isRequired={requiredFields.includes(SUB_MODULE)}
                    disabled={isView}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-3 absolute bottom-0 w-full bg-white pb-[25px] z-[3]">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </Button>
              {isView ? (
                <></>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? "Submitting..." : isEdit ? "Update" : "Submit"}
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
